var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHidepassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.96 13.96C12.8204 14.8287 11.4328 15.3099 10 15.3334C5.33335 15.3334 2.66669 10 2.66669 10C3.49595 8.45463 4.64611 7.10444 6.04002 6.04004M8.60002 4.8267C9.05891 4.71929 9.52873 4.6656 10 4.6667C14.6667 4.6667 17.3334 10 17.3334 10C16.9287 10.7571 16.4461 11.4699 15.8934 12.1267M11.4134 11.4134C11.2303 11.6099 11.0095 11.7675 10.7641 11.8768C10.5188 11.9861 10.254 12.0449 9.98542 12.0496C9.71687 12.0544 9.45013 12.005 9.2011 11.9044C8.95206 11.8038 8.72584 11.6541 8.53592 11.4641C8.346 11.2742 8.19628 11.048 8.09569 10.799C7.9951 10.5499 7.94571 10.2832 7.95044 10.0146C7.95518 9.7461 8.01396 9.48127 8.12327 9.23593C8.23258 8.9906 8.39019 8.7698 8.58669 8.5867",
    stroke: "#190D1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66669 2.66669L17.3334 17.3334",
    stroke: "#190D1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidepassword);
export default __webpack_public_path__ + "static/media/Hidepassword.f9efa88d113bc32591b896727ed55593.svg";
export { ForwardRef as ReactComponent };